class VideoEmbed {
  static init() {
    const videosWrapper = document.querySelectorAll(".product-subsection");
    videosWrapper.forEach(function (videoWrapper) {
      if (videoWrapper) return new VideoEmbed(videoWrapper);
    });
  }
  constructor(videoWrapper = null) {
    if (videoWrapper) {
      this.videoWrapper = videoWrapper;
      this.productVideos = new Map();
      this.videoWrapper.querySelectorAll(".video-embed").forEach((e) => {
        let t = e.getAttribute("id").replace("VideoEmbed-", "");
        this.productVideos.set(t, e);
        this.initPlyr(t);
      });
    }
  }
  initPlyr(id) {
    const player = new Plyr(`#player-${id}`);
    let videoWrapper;
    if (this.videoWrapper) {
      videoWrapper = this.productVideos.get(id);
    } else {
      videoWrapper = document.querySelector(`#VideoEmbed-${id}`);
    }

    const stopButton = videoWrapper.parentElement.querySelector(
      `#ButtonStop-${id}`
    );

    if (this.videoWrapper) {
      player.on("ready", function () {
        let videoTitle;
        setTimeout(() => {
          videoTitle = player.config.title;
          let videoTitleElm = videoWrapper.querySelector(".video-embed__title");
          if (videoTitleElm) {
            videoTitleElm.innerText = videoTitle;
          }
        }, 100);
      });
    }

    player.on("playing", function () {
      let isSection = videoWrapper.getAttribute("data-section");
      if (!isSection || isSection === null) {
        document.body.classList.add("video-embed-playing");
      } else {
        document.body.classList.add("section-video-playing");
      }
      document.body.parentElement.classList.add("video-embed-playing");
      videoWrapper.parentNode.classList.add("video-container-playing");
    });

    if (stopButton) {
      stopButton.addEventListener("click", () => {
        player.pause();
        document
          .querySelectorAll(".video-container-playing")
          .forEach((elm) => elm.classList.remove("video-container-playing"));
        document.body.parentElement.classList.remove("video-embed-playing");
        document.body.classList.remove("video-embed-playing");
        document.body.classList.remove("section-video-playing");
      });
    }
  }
}

function closeLightBox() {
  const button = document.querySelector("button#CloseLigthbox");
  if (!button) return;

  button.addEventListener("click", () => {
    document
      .querySelectorAll(".video-container-playing")
      .forEach((elm) => elm.classList.remove("video-container-playing"));
    document.body.parentElement.classList.remove("video-embed-playing");
    document.body.classList.remove("video-embed-playing");
  });
}

closeLightBox();

window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    VideoEmbed.init();
  }, 100);
});

document.addEventListener("plyr-event", (e) => {
  const videoZendesk = new VideoEmbed();
  videoZendesk.initPlyr(e.detail.id);
});
